<script lang="ts" setup>
interface Props {
  title?: string
  value: string
  inline?: boolean
}

defineProps<Props>()
</script>

<template>
  <div
    class="car-parameter px-2 text-[#58585a] md:px-1.5"
    :class="{ 'mb-3 flex items-center': !inline, 'mb-1': inline }"
  >
    <CommonTooltip :tooltip="title" show-on-mobile class="w-full sm:w-auto">
      <span
        class="relative z-10 flex items-center justify-center md:inline-flex md:flex-row md:justify-start"
        :class="[!inline ? 'flex-col' : '']"
        @click.stop
      >
        <span
          class="inline-block md:mb-0"
          :class="{
            'md:hidden': $slots.default ? false : true,
            'mr-1.5 w-6': inline,
            'mb-2 h-6 w-6 min-w-6 md:mr-4 md:h-auto md:w-8 md:min-w-8': !inline,
          }"
        >
          <slot />
        </span>
        <span
          class="car-parameter-value w-full sm:w-auto"
          v-html="value"
        />
      </span>
    </CommonTooltip>
  </div>
</template>

<style lang="scss">
@media (max-width: 767px) {
  .car-parameter {
    svg {
      width: auto;
      height: 32px;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .car-parameter {
    &:not(:last-child) {
      .car-parameter-value {
        position: relative;

        &::after {
          content: '|';
          position: absolute;
          right: -10px;
          top: 0;
        }
      }
    }
  }
}
</style>
